// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Select} from '@wandb/weave/components/Form/Select';
// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';
import {components, MenuProps, SingleValue} from 'react-select';

export type RegistryOption = {
  label: string;
  value: string;
};

type SelectArtifactRegistryProps = {
  options: RegistryOption[];
  disabled?: boolean;
  value: SingleValue<RegistryOption> | undefined;
  onChange: (option: SingleValue<RegistryOption>) => void;
  onCreateClick?: () => void;
  placeholder?: string;
};

export const SelectArtifactRegistry = ({
  options,
  disabled,
  value,
  onChange,
  onCreateClick,
  placeholder = 'Select registry',
}: SelectArtifactRegistryProps) => {
  const customSelectComponents = {
    Menu: (props: MenuProps<RegistryOption, false>) => (
      <components.Menu {...props}>
        {props.children}
        {onCreateClick && (
          <div
            className="border-t border-moon-250 cursor-pointer py-4 px-6 w-auto"
            onClick={onCreateClick}
            data-test="select-artifact-registry-create-new">
            <div className="flex items-center gap-4 py-14 px-10 rounded text-moon-800 hover:bg-moon-100">
              <Icon name="add-new" />
              <span>Create new registry</span>
            </div>
          </div>
        )}
      </components.Menu>
    ),
  };

  return (
    <Tailwind>
      <Select<RegistryOption, false>
        options={options}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        isDisabled={disabled}
        components={onCreateClick ? customSelectComponents : undefined}
      />
    </Tailwind>
  );
};
